import React, { useEffect, useRef, useState } from 'react'
import { Button, Col, Modal, Overlay, Row, Tooltip } from 'react-bootstrap';
import styles from './EmailModal.module.scss';
import { File, Files } from 'react-bootstrap-icons';
import { useParams } from 'react-router-dom';
import Axios from 'services/BackendApi/BackendApi.js';
import ReactMultiEmail from 'react-multi-email';
import 'react-multi-email/dist/style.css';

// IMAGENES E ICONOS
import logo_email from 'assets/img/JPE_email.jpg';
import { MdEmail } from "react-icons/md";
import { PulseLoader } from 'react-spinners';
import Alert from 'modules/website/components/Alert/Alert';

export default function EmailModal(props) {
    const { show, handleClose, titleName } = props;
    const [link, setLink] = useState(window.location.href);

    //console.log(titleName);

    /* const [formData, setFormData] = useState({
        destination: [],
        name: "",
        email: "",
        title: titleName,
        url: link,
        message: ""
    }); */
    const [formData, setFormData] = useState({
        destination: "",
        name: "",
        email: "",
        title: titleName,
        url: link,
        message: ""
    });
    const [response, setResponse] = useState({
        isLoading: false,
        isError: false,
        payload: {
            message: '',
        },
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    /* const handleSubmit = (e) => {
        e.preventDefault();
        console.log("Formulario enviado con los siguientes datos:", formData);
        
    }; */
    const handleSubmit = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const form = e.currentTarget;
        if (form.checkValidity() === false) return;
        //console.log('Form data:', formData);
        sendData();
    };

    const sendData = async () => {
        try {
            setResponse((prevResponse) => ({
                ...prevResponse,
                isLoading: true,
            }));
            const { data } = await Axios.SendContactForm(formData);
            const validRespose = Boolean(data?.success);
            setResponse((prevResponse) => ({
                ...prevResponse,
                isLoading: false,
                isError: !validRespose,
                payload: {
                    message: data.message,
                },
            }));
            //validRespose && resetForm();
        } catch (error) {
            console.log(error);
            setResponse((prevResponse) => ({
                ...prevResponse,
                isLoading: false,
                isError: true,
                payload: {
                    message: error?.message ?? 'Error al enviar el mensaje',
                },
            }));
        }
    };
    console.log(response);
    return (
        <Modal show={show} onHide={handleClose} className={styles.modal} centered>
            <Modal.Header
                closeButton
                style={{ borderBottom: 'none', backgroundColor: '#000' }}
                closeVariant='white'
            >
                <Modal.Title style={{ color: 'white', fontSize: '24px' }} className='d-flex align-items-center'>
                    <MdEmail className='mx-2' />
                    E-mail
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className={styles.mBody}>
                <div className='d-flex align-items-center justify-content-center'>
                    <img
                        src={logo_email}
                        alt="JPEE email logo"
                        className={styles.logo_email}
                    />
                </div>

                <div style={{ width: '100%', backgroundColor: '#C8C6C7', height: '1px', margin: '10px auto' }}></div>

                <form onSubmit={handleSubmit}>
                    <Row className={styles.form_container}>
                        {/* <Col xs={12} className="mb-2">
                            <div className="d-flex flex-column flex-lg-row align-items-lg-center mb-3">
                                <label className="mb-1 mb-lg-0 me-lg-2" style={{ width: "40%", fontWeight: "bold", whiteSpace: "nowrap" }}>
                                    Destination address(es):
                                </label>
                                <ReactMultiEmail
                                    emails={formData.destination}  // Aquí usamos el array directamente
                                    //onChange={(emails) => setFormData({ ...formData, destination: emails })}  // Actualizamos el estado con el array de correos
                                    placeholder="e.g. user1@example.com, user2@example.com"
                                    className="form-control"
                                />
                            </div>
                        </Col> */}
                        {[
                            { label: "Destination address(es):", name: "destination", placeholder: "e.g. user@example.com", type: "email" },
                            { label: "Your name:", name: "name", placeholder: "e.g. John Doe", type: "text" },
                            { label: "Your e-mail address:", name: "email", placeholder: "e.g. johndoe@example.com", type: "email" },
                        ].map((field, index) => (
                            <Col md={12} className="mb-2" key={index}>
                                <div className="d-flex flex-column flex-lg-row align-items-lg-center mb-3">
                                    <label className="mb-1 mb-lg-0 me-lg-2" style={{ width: "40%", fontWeight: "bold", whiteSpace: "nowrap" }}>
                                        {field.label}
                                    </label>
                                    <input
                                        type={field.type}
                                        name={field.name}
                                        placeholder={field.placeholder}
                                        className="form-control"
                                        value={formData[field.name]}
                                        onChange={handleChange}
                                    //equired
                                    />
                                </div>
                            </Col>
                        ))}
                        <Col md={12} className="mb-2">
                            <div className="d-flex flex-column flex-lg-row align-items-lg-center">
                                <label className={`mb-1 mb-lg-0 me-lg-2 ${styles.label_text}`}>
                                    Title of the document:
                                </label>
                                <div className={styles.form_control_text}>
                                    <p className={styles.text_value}>{titleName}</p>
                                    <input type="hidden" name="title" value={titleName} />
                                </div>
                            </div>
                        </Col>

                        <Col md={12} className="mb-2">
                            <div className="d-flex flex-column flex-lg-row align-items-lg-center">
                                <label className={`mb-1 mb-lg-0 me-lg-2 ${styles.label_text}`}>
                                    Direct URL:
                                </label>
                                <div className={styles.form_control_text}>
                                    <p className={styles.url_value}>
                                        {formData.url}
                                    </p>
                                    <input type="hidden" name="url" value={formData.url} />
                                </div>
                            </div>
                        </Col>

                        <Col md={12} className="mb-2">
                            <div className="d-flex flex-column flex-lg-row align-items-lg-center">
                                <label className="mb-1 mb-lg-0 me-lg-2" style={{ width: "40%", fontWeight: "bold", whiteSpace: "nowrap" }}>
                                    Your message:
                                </label>
                                <textarea
                                    name="message"
                                    placeholder="Write your message"
                                    className="form-control"
                                    rows="4"
                                    value={formData.message}
                                    onChange={handleChange}
                                    style={{ resize: "vertical", width: "100%" }}
                                />
                            </div>
                        </Col>
                    </Row>

                    <Row>
                        <Col className="d-flex justify-content-center mt-4">
                            <Button type="submit" variant="primary" className={`me-2 ${styles.send_message}`}>
                                {
                                    response.isLoading ? (
                                        <PulseLoader
                                            loading={true}
                                            size={5}
                                            color="white"
                                            aria-label="Loading Spinner"
                                            data-testid="loader"
                                        />
                                    ) : (
                                        <>
                                            Send Message
                                        </>
                                    )
                                }
                            </Button>
                            <Button variant="secondary" onClick={handleClose} className={styles.cancel}>
                                Cancel
                            </Button>
                        </Col>
                    </Row>
                    {!response.isLoading && response.payload.message && !response.isError ? (
                        <Alert
                            variant={'success'}
                            className={`mt-3 text-wrap ${styles.alert}`}
                            style={{ width: '100%' }}
                        >
                            {response.payload.message}
                        </Alert>
                        
                    ): (
                        !response.isLoading && response.isError && (
                        <Alert
                            variant={'danger'}
                            className={`mt-3 text-wrap ${styles.alert}`}
                            style={{ width: '100%' }}
                        >
                            Error sending the message
                        </Alert>
                        )
                    )}
                    {/* <p
                            className={`mt-3 text-wrap fw-bold ${response.isError ? 'text-danger' : ''
                                }`}
                        >
                            {response.payload.message}
                        </p> */}
                </form>
            </Modal.Body>
        </Modal>
    )
}
